
















































import { Component, Vue, Prop, Watch, Emit, Mixins } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import GuardNoteList from "@/components/mobile/dispatch/GuardNoteList.vue";
import { DispatchRequest, QuickClose } from "@/store/mobile/types";
import GuardTourActions from "./GuardTourActions.vue";
import { GuardTour, GuardTourStep } from "@/store/guard-tours/types";
import FinishContinueButton from "@/components/mobile/dispatch/FinishContinueButton.vue";
import DispatchMixin from "@/mixins/DispatchMixin";

const Mobile = namespace("mobile");
const Tasks = namespace("tasks");
const GuardTours = namespace("GuardTours");

@Component({
	components: {
		"guard-note-list": GuardNoteList,
		"guard-tour-actions": GuardTourActions,
		"finish-continue-button": FinishContinueButton
	}
})
export default class DispatchDetails extends Mixins(DispatchMixin) {
	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
	@Mobile.State(state => state.QuickCloseList) quickCloseList: QuickClose[];

	public expandCollapse: boolean = true;
	public saveNote: boolean = false;

	@Emit("finished-dispatch")
	public emitFinishedDispatch(dispatchQueueID: number) {
		this.saveNote = !this.saveNote;
		return dispatchQueueID;
	}

	// Emit quick close so the core component can update view to quick close.
	@Emit("quick-close")
	public emitQuickClose() {}

	private toggleMinimize() {
		this.expandCollapse = !this.expandCollapse;
	}	
}
